import gql from 'graphql-tag'

export const SUBSCRIBE_ALL_USERS = gql`
    subscription($orgId:uuid!) {
        Users: Users(where:{organizationId:{_eq: $orgId}}, order_by: {updated_at: desc}){
            id
            name
            email
            mobile
            created_at
            userTypeId
            status
            Type{
                id
                name
            }
        }
    }`
